export const MAX_FOLLOW_UP_COMMENT_LENGTH = 8000;
export const MAX_YOUTUBE_TITLE_LENGTH = 100;

const FOLLOW_UP_COMMENT_SUPPORTED = new Set([
  "facebook",
  "instagram",
  "linkedin"
]);

export function supportsFollowUpComment(platform) {
  return FOLLOW_UP_COMMENT_SUPPORTED.has(String(platform || "").toLowerCase());
}

export function normalizeFacebookPostType(value) {
  const normalized = String(value || "post").toLowerCase();
  if (normalized === "reel" || normalized === "story") {
    return normalized;
  }
  return "post";
}

export function facebookPostTypeLabel(postType) {
  if (postType === "reel") return "Reel";
  if (postType === "story") return "Story";
  return "Feed";
}

export function facebookPostTypeRequiresVideo(postType) {
  return postType === "reel" || postType === "story";
}

export function normalizeYoutubePostType(value) {
  const normalized = String(value || "video").toLowerCase();
  return normalized === "short" ? "short" : "video";
}

export function normalizeYoutubePrivacy(value) {
  const normalized = String(value || "public").toLowerCase();
  if (normalized === "unlisted" || normalized === "private") {
    return normalized;
  }
  return "public";
}

export function followUpCommentPlatformsLabel() {
  return "Facebook Pages, Instagram Business, and LinkedIn";
}

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i;
const VIDEO_EXT = /\.(mp4|mov|webm|m4v)(\?.*)?$/i;

export function isVideoMediaUrl(url) {
  return VIDEO_EXT.test(String(url || "").trim());
}

export function isImageMediaUrl(url) {
  const value = String(url || "").trim();
  if (!value || isVideoMediaUrl(value)) return false;
  return IMAGE_EXT.test(value);
}

export function contentHasVideo(mediaUrls = []) {
  return mediaUrls.some((url) => isVideoMediaUrl(url));
}

export function hasPendingVideoFiles(pendingFiles = []) {
  return pendingFiles.some((item) => item && item.file && !item.isImage);
}

export function stripVideoMediaUrls(urls = []) {
  return urls
    .map((url) => String(url || "").trim())
    .filter(Boolean)
    .filter((url) => !isVideoMediaUrl(url));
}

export function keepSingleVideoMediaUrl(urls = []) {
  const normalized = urls
    .map((url) => String(url || "").trim())
    .filter(Boolean);
  const nonVideo = normalized.filter((url) => !isVideoMediaUrl(url));
  const videos = normalized.filter((url) => isVideoMediaUrl(url));
  if (!videos.length) {
    return nonVideo;
  }
  return [...nonVideo, videos[videos.length - 1]];
}
